import * as React from 'react';
import InputContainer from 'src/modules/commons/inputs/input/Input.container';
import countries from 'src/stubs/countries';

export interface CountrySelectComponentProps {
  value?: string;
  label?: string;
  required: boolean;
  onChange: (value: string) => void;
}

const CountrySelectComponent = (props: CountrySelectComponentProps) => {
  const currentCountry = countries.find((country) => country.code === props.value);
  
  return (
    <div className="dropdown">
      <div
        className="md-input dropdown-toggle"
        data-toggle="dropdown"
        role="button"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <InputContainer
          label={props.label ? props.label : 'País'}
          value={currentCountry ? currentCountry.name : ''}
          type="text"
          required={props.required}
          readOnly={true}
          onChange={() => { return; }}
        />
        <span className="d-arrow-down icon-error-input" />

      </div>
      <ul
        className="dropdown-menu"
        style={{
          height: '400px',
          overflow: 'auto'
        }}
      >
        {
          countries.map(country => ([
            <li
              key={country.code}
              onClick={() => props.onChange(country.code)}
            >
              {country.name}
            </li>,
            <li
              key={country.name + '-separator'}
              role="separator"
              className="divider"
            />
          ]))
        }
      </ul>
    </div>
  );
};

export default CountrySelectComponent;



// WEBPACK FOOTER //
// ./src/modules/commons/inputs/country-select/CountrySelect.component.tsx